import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="quick-customer"
// customer:created (dispatched by admin/users/create.turbo_stream.erb) is
// handled by hw_combobox_controller#handleCustomerCreated, which sets the
// combobox's values directly and hides this form -- see that controller
// for the single source of truth on post-creation cleanup.
export default class extends Controller {
  static targets = ["form", "toggleIcon", "field"]

  toggleForm(event) {
    event.preventDefault()
    
    // Toggle form visibility
    this.formTarget.classList.toggle('hidden')
    
    // Toggle required attribute based on visibility
    if (this.formTarget.classList.contains("hidden")) {
      // Form is now hidden - remove required attributes
      this.fieldTargets.forEach(field => {
        field.removeAttribute('required')
      })
      this.toggleIconTarget.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />'
    } else {
      // Form is now visible - add required attributes
      this.fieldTargets.forEach(field => {
        field.setAttribute('required', 'required')
      })
      this.toggleIconTarget.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4" />'
    }
  }
}
